"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_table_1 = require("react-table");
var react_jss_1 = require("react-jss");
var __1 = require("..");
var createSubRows_1 = __importDefault(require("./createSubRows"));
var useSubRowStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors, margins = _a.margins;
    return ({
        cell: {
            backgroundColor: colors.Grey[0],
            borderRight: "1px solid ".concat(colors.Grey[300]),
            borderBottom: "1px solid ".concat(colors.Grey[300]),
            padding: "".concat(margins.xs, "px ").concat(margins.sm, "px"),
        },
        hideBottomBorder: {
            borderBottom: 'none',
        },
        row: {
            '& :first-child': {
                borderLeft: 'none',
            },
            '& :last-child': {
                borderRight: 'none',
            },
        },
    });
});
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors, margins = _a.margins;
    return ({
        table: {
            borderSpacing: 0,
        },
        headerCell: {
            backgroundColor: colors.Grey[100],
            textAlign: 'start',
            padding: "".concat(margins.xs, "px ").concat(margins.sm, "px"),
            borderTop: "1px solid ".concat(colors.Grey[300]),
            borderBottom: "1px solid ".concat(colors.Grey[300]),
        },
    });
});
var Table = function (_a) {
    var columns = _a.columns, data = _a.data, customRowProps = _a.customRowProps, rest = __rest(_a, ["columns", "data", "customRowProps"]);
    var classes = useStyles();
    var subRowClasses = useSubRowStyles();
    var tableInstance = (0, react_table_1.useTable)({ columns: columns, data: data });
    var getTableProps = tableInstance.getTableProps, getTableBodyProps = tableInstance.getTableBodyProps, headerGroups = tableInstance.headerGroups, rows = tableInstance.rows, prepareRow = tableInstance.prepareRow, getHooks = tableInstance.getHooks;
    var hooks = getHooks();
    var getRowProps = hooks.getRowProps;
    if (customRowProps) {
        getRowProps.push(customRowProps);
    }
    return (react_1.default.createElement("table", __assign({}, getTableProps(), { className: classes.table }, rest),
        react_1.default.createElement("thead", null, headerGroups.map(function (headerGroup) { return (react_1.default.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (react_1.default.createElement("th", __assign({}, column.getHeaderProps(), { className: classes.headerCell }),
            react_1.default.createElement(__1.Typography, { variant: 'textSmall' }, column.render('Header')))); }))); })),
        react_1.default.createElement("tbody", __assign({}, getTableBodyProps()), rows.map(function (row, i) {
            prepareRow(row);
            var _a = row.getRowProps().className, className = _a === void 0 ? '' : _a;
            return (0, createSubRows_1.default)(row, i === rows.length - 1, __assign(__assign({}, subRowClasses), { row: "".concat(subRowClasses.row, " ").concat(className) }));
        }))));
};
exports.default = Table;
//# sourceMappingURL=index.js.map